import { Schema } from '@core/data/dto/schema';
import { Employee } from '../employee';
import { ChildSupport } from './child-support';
import { Miscellaneous } from './miscellaneous';

export const DeductionSchema = {
    id: Schema.String,
    provider: Schema.String,
    provider_id: Schema.String,
    source: Schema.String,
    external: Schema.Boolean,
    type: Schema.Auto,
    employee: Employee,
    description: Schema.String,
    effective_start: Schema.Moment,
    effective_end: Schema.Moment,
    miscellaneous: Miscellaneous,
    miscellaneous_garnishment: Miscellaneous,
    child_support: ChildSupport,
    managed: Schema.Boolean
}
